var map = {
	"./pr-1.png": "9920",
	"./pr-2.png": "595f",
	"./pr-3.png": "b56e",
	"./pr-4.png": "dd56",
	"./pr-5.png": "9919",
	"./pr-6.png": "03e5",
	"./pr-7.png": "974e",
	"./pr-8.png": "046f"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "da74";